<template>
  <div id="login-wrapper" class="login-wrapper">
    <profile-select
      v-if="isVisibleProfileSelect"
      :close-fn="closeOnSuccess"
    ></profile-select>
    <div class="login-mode">
      <div class="login-header">
        <h1 class="pooq-logo">
          <Logo />
        </h1>
        <button class="btn-back" type="button" @click.prevent="close">
          <span class="a11y-hidden">뒤로 가기</span>
          <span class="icon-back"><GnbBackIcon></GnbBackIcon></span>
        </button>
      </div>
      <!--
      <div @click.prevent="close"> 닫기 </div>
      -->
      <div class="login-input">
        <label for="id"
          ><span class="a11y-hidden">이메일 주소 또는 아이디 : </span></label
        >
        <input
          id="id"
          v-model="id"
          type="text"
          placeholder="이메일 주소 또는 아이디"
          autocomplete="off"
        />
        <p v-if="isEmptyIdOrPassword && id === ''" class="noti-purple">
          <span class="join-noti-ico"><InfoPurple /></span>
          <span class="join-noti-text">이메일 또는 아이디를 입력해주세요.</span>
        </p>
      </div>
      <div class="login-input">
        <label for="pw"><span class="a11y-hidden">패스워드 : </span></label>
        <input
          id="pw"
          ref="login"
          v-model="password"
          :type="hidePassword ? 'password' : 'text'"
          placeholder="비밀번호"
          autocomplete="off"
          @keyup.enter="goLogin"
        />
        <p
          v-if="isEmptyIdOrPassword && password === '' && id !== ''"
          class="noti-purple"
        >
          <span class="join-noti-ico"><InfoPurple /></span>
          <span class="join-noti-text">비밀번호를 입력해주세요.</span>
        </p>
        <button
          class="input-btn"
          type="button"
          @click.stop="togglePasswordInputType"
        >
          {{ hidePassword ? 'show' : 'hide' }}
        </button>
      </div>
      <div class="login-auto">
        <input id="keep-login" v-model="keepLogin" type="checkbox" />
        <label for="keep-login"
          >로그인 상태 유지
          <span class="a11y-hidden">{{ keepLogin }}</span></label
        >
      </div>
      <button class="login" type="button" @click.prevent="goLogin">
        로그인
      </button>
      <div class="login-help">
        <ul>
          <li>
            <a
              href=""
              @click.prevent="
                () =>
                  moveExternalSite(
                    'https://member.wavve.com/mobile/find/id?device=mobile',
                  )
              "
              >아이디 찾기</a
            >
            <span class="ver-line"></span>
          </li>
          <li>
            <a
              href=""
              @click.prevent="
                () =>
                  moveExternalSite(
                    'https://member.wavve.com/mobile/find/password?device=mobile',
                  )
              "
              >비밀번호 재설정</a
            >
            <span class="ver-line"></span>
          </li>
          <li>
            <a href="#" @click.prevent="signUp">회원가입</a>
          </li>
        </ul>
      </div>
      <div class="login-sns">
        <div class="login-line-box">
          <span>또는 다른 서비스 계정으로 로그인</span>
        </div>
        <ul>
          <li class="login-sns-each kakao">
            <BtnKaKao
              :show-profile-fn="showProfileSelect"
              :close-on-success-fn="closeOnSuccess"
              :promotion-code="promotionCode"
            />
          </li>
          <li class="login-sns-each tworld">
            <BtnSkt :promotion-code="promotionCode" />
          </li>
          <li class="login-sns-each naver">
            <BtnNaver
              :show-profile-fn="showProfileSelect"
              :close-on-success-fn="closeOnSuccess"
              :promotion-code="promotionCode"
            />
          </li>
          <li class="login-sns-each facebook">
            <BtnFaceBook
              :show-profile-fn="showProfileSelect"
              :close-on-success-fn="closeOnSuccess"
              :promotion-code="promotionCode"
            />
          </li>
          <li class="login-sns-each apple">
            <BtnApple />
          </li>
        </ul>
      </div>
      <p class="sns-exclamation">
        <span
          >SNS계정으로 간편하게 가입하여 서비스를 이용하실 수 있습니다. 기존
          POOQ 계정 또는 Wavve 계정과는 연동되지 않으니 이용에 참고하세요.</span
        >
      </p>
    </div>
  </div>
</template>

<script>
  import { get, trim } from 'lodash'
  import GnbBackIcon from '@/assets/svg/common/ic_gnb_back_w.svg'
  import Logo from '@/assets/svg/logo/logo.svg'
  import BtnFaceBook from '@/components/lnb/login/BtnFacebook'
  import BtnKaKao from '@/components/lnb/login/BtnKakao'
  import BtnNaver from '@/components/lnb/login/BtnNaver'
  import BtnSkt from '@/components/lnb/login/BtnSkt'
  import BtnApple from '@/components/lnb/login/BtnApple'
  import InfoPurple from '@/assets/svg/common/ic-info-p.svg'
  import utils from '@/common/util/utils'
  import ProfileSelect from '@/views/lnb/ProfileSelect'
  import { mapMutations } from 'vuex'
  import {
    displayNone,
    removeNone,
    categorySearchNeedlessLogin,
  } from '@/common/util/ui.utils'
  import { MENU_HOME } from '@/common/menu/menu.const'
  import { parseUrl } from 'query-string'
  import { URL_COOKIE_DOMAIN } from '@/common/constant'

  export default {
    name: 'Login',
    components: {
      BtnFaceBook,
      BtnKaKao,
      BtnNaver,
      BtnSkt,
      BtnApple,
      GnbBackIcon,
      Logo,
      InfoPurple,
      ProfileSelect,
    },
    data() {
      return {
        viewMode: false,
        keepLogin: false,
        hidePassword: true,
        isInvalidEmailOrId: false,
        isEmptyIdOrPassword: false,
        isVisibleProfileSelect: false,
        id: '',
        password: '',
        promotionCode: '',
      }
    },
    methods: {
      ...mapMutations(['hideLoginView']),
      goAutoLogin() {
        location.href = 'https://m.wavve.com/getcredential'
      },
      moveExternalSite(url) {
        utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
        const referer = get(this.$route, ['query', 'referer'], '')
        if (referer !== '') {
          utils.cookies.setItem('referer-url', referer)
        }
        location.href = url
      },
      infoMessageClear() {
        this.isInvalidEmailOrId = false
        this.isEmptyIdOrPassword = false
      },
      togglePasswordInputType() {
        this.hidePassword = !this.hidePassword
      },
      close() {
        categorySearchNeedlessLogin()
        if (this.viewMode) {
          removeNone('.app-wrapper')
          if (this.$route.query.login === 'n') {
            this.$router.back()
          } else {
            this.hideLoginView()
          }
        } else {
          const referer = utils.cookies.getItem('referer-url')
          if (referer !== '' && referer !== null) {
            utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
            this.$router.replace(referer.replace(location.origin, ''))
          } else {
            this.$router.back()
          }
        }
      },
      closeOnSuccess() {
        categorySearchNeedlessLogin()

        if (this.viewMode) {
          if (this.$route.query.login === 'n') {
            this.$router.back()
          } else {
            this.hideLoginView()
          }
        } else {
          const beforePage = document.referrer
          if (beforePage.indexOf('member.') > -1) {
            const referer = utils.cookies.getItem('referer-url')
            if (referer !== '' && referer !== null) {
              utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
              if (referer.indexOf('http') > -1) {
                location.href = referer
              } else {
                this.$router.replace(referer.replace(location.origin, ''))
              }
            } else {
              // info: 외부 페이지에서 리다이렉트 시켯을때
              this.$router.replace({ name: MENU_HOME })
            }
          } else {
            const referer = get(this.$route, ['query', 'referer'], '')
            if (referer !== '') {
              utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
              if (referer.indexOf('http') > -1) {
                location.href = referer
              } else {
                this.$router.replace(referer.replace(location.origin, ''))
              }
            } else {
              location.href = location.protocol + '//' + location.host
            }
          }
        }
      },
      goLogin() {
        this.$refs['login'].blur()
        if (trim(this.id).length === 0 || trim(this.password).length === 0) {
          this.$nextTick(() => {
            this.isEmptyIdOrPassword = true
          })
          return
        }
        utils.login
          .loginProc({
            userType: 'general',
            userId: this.id,
            userPassword: this.password,
            autoLogin: this.keepLogin,
            saveId: '',
          })
          .then((response) => {
            if (response.data.needselectprofile === 'y') {
              // 프로필 선택 화면이 필요하면
              this.isVisibleProfileSelect = true
            } else {
              this.closeOnSuccess()
            }
            removeNone('.app-wrapper')
          })
      },
      goSnsLogin(type, token, promotionCode) {
        utils.login
          .loginProc(
            {
              userType: type,
              userId: token,
              userPassword: '',
              autoLogin: '',
              saveId: '',
            },
            (error) => {
              if (
                error.response.status === 551 &&
                error.response.data.resultcode === '302'
              ) {
                window.location.href =
                  error.response.data.resultoptional +
                  '&promotioncode=' +
                  promotionCode
              }
            },
          )
          .then((response) => {
            if (response.data.needselectprofile === 'y') {
              // 프로필 선택 화면이 필요하면
              this.isVisibleProfileSelect = true
            } else {
              this.closeOnSuccess()
            }
            removeNone('.app-wrapper')
          })
      },
      showProfileSelect() {
        this.isVisibleProfileSelect = true
      },
      hideProfileSelect() {
        this.isVisibleProfileSelect = false
      },
      signUp() {
        const url = 'https://member.wavve.com/mobile/account'
        location.href =
          this.promotionCode !== ''
            ? `${url}?promotioncode=${this.promotionCode}`
            : url
      },
    },
    watch: {
      id() {
        this.infoMessageClear()
      },
      password() {
        this.infoMessageClear()
      },
    },
    created() {
      if (this.$route.name !== 'login') {
        displayNone('.app-wrapper')
        this.viewMode = true
      }
      const existCredential = utils.cookies.getCredential() !== 'none'
      const { query } = parseUrl(location.href)
      const referer = get(query, 'referer', '')
      const refererParseUrl = parseUrl(referer)
      this.promotionCode = get(refererParseUrl, 'query.promotioncode', '')
      const adult = get(query, 'adult', 'n')
      if (adult !== 'y')
        utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
      if (referer !== '' && adult !== 'y') {
        utils.cookies.setItem(
          'referer-url',
          referer,
          null,
          URL_COOKIE_DOMAIN,
          '/',
        )
      }
      if (existCredential) {
        if (referer !== '') {
          location.href = referer
        } else {
          this.$router.back()
        }
      } else {
        const type = get(this.$route, 'query.type', '')
        const token = get(this.$route, 'query.token', '')
        const promotionCode = get(this.$route, 'query.promotioncode', '')
        if (type !== '' && token !== '') {
          this.goSnsLogin(type, token, promotionCode)
        }
      }
    },
    beforeDestroy() {
      removeNone('.app-wrapper')
    },
  }
</script>
<style scoped>
  .noti-purple,
  .noti-red {
    padding: 6px 0 12px;
    font-size: 0;
  }
  .noti-purple {
    color: #ff27a3;
  }
  .noti-purple > span {
    display: inline-block;
    vertical-align: middle;
  }
  .join-noti-ico {
    font-size: 0;
  }
  .join-noti-text {
    margin-left: 4px;
    font-size: 12px;
    line-height: 18px;
    color: #ff27a3;
  }
</style>
